import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getUserProfileInfo } from '../actions/userManagementActions';
import { getUserProfileInfoSelector } from '../actions/userManagementActions/selectors';
import isSiteExternal from '../utils/isSiteExternal';

export const useUserProfile = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(getUserProfileInfoSelector);
  useEffect(() => {
    if (isEmpty(user) && isSiteExternal())
      dispatch(getUserProfileInfo.request({ history }));
  }, [dispatch, history, user]);

  return user;
};

export default useUserProfile;
